import { Controller } from "stimulus";
import Masonry from "masonry-layout";

export default class extends Controller {
    static targets = [ 'item' ];
    resizeTimer = null;

    initialize() {
        this.onResize = this.onResize.bind(this);
    }

    connect() {
        window.addEventListener('load', () => {
            this.init();
        })

        window.addEventListener('resize', this.onResize);
       
    }

    onResize() {
        let scope = this;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function() {
            // Reload layout sizing 
            scope.msnry.destroy();
            scope.init();
        }, 250);
    }

    init() {
        this.msnry = new Masonry( this.element, {
          // options...
            columnWidth: '[data-grid-sizer]',
            gutter: '[data-gutter-sizer]',
            itemSelector: '[data-item]',
            percentPosition: true,
            isResizable: true
        });
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/masonry_controller.js